export default __webpack_public_path__ + "static/media/coin_bnb.a9a5372f.svg";